<ng-container *msShowInEpcot="false">
    @if (isEventSelected) {
        <vn-icon name="theme-info-i" size="12" />
    }
    <ms-dynamic-icon [html]="message()" />
</ng-container>
<ng-container *msShowInEpcot="true">
    @if (isEventSelected) {
        <ms-epcot-notification [message]="message()" [notificationType]="'info'" />
    } @else {
        <ms-dynamic-icon [html]="message()" />
    }
</ng-container>
